import { inject, InjectionToken, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '@auth0/auth0-angular';
import { map } from 'rxjs';

/** The signed-in user as the page shows them, and the way out. */
export interface AuthSession {
    /** The user's display name or email; null while unknown or when no one is signed in. */
    userName: Signal<string | null>;
    logout(): void;
}

export const AUTH_SESSION = new InjectionToken<AuthSession>('AUTH_SESSION');

/** Reads the session from auth0-angular and logs out back to this origin. */
export function auth0Session(): AuthSession {
    const auth = inject(AuthService);
    return {
        userName: toSignal(auth.user$.pipe(map(user => user?.name ?? user?.email ?? null)), {
            initialValue: null
        }),
        logout: () => auth.logout({ logoutParams: { returnTo: window.location.origin } })
    };
}

/** The session of a stage without Auth0: nobody is signed in and logging out does nothing. */
export const noSession: AuthSession = {
    userName: (() => null) as Signal<string | null>,
    logout: () => undefined
};
